import QRCode from "qrcode";

/**
 * Gera um QR Code (PNG) como Data URL, pronto para usar em `<img :src>`.
 * Geração 100% client-side (sem chamar serviço externo) — essencial para um display
 * de kiosk que precisa seguir funcionando mesmo com rede instável.
 * @param {string} texto Conteúdo do QR Code (ex.: link do Google Agenda)
 * @param {{ width?: number, margin?: number, corEscura?: string, corClara?: string }} [opcoes]
 * @returns {Promise<string>} Data URL `data:image/png;base64,...` (string vazia em caso de falha)
 */
export async function gerarQrCodeDataUrl(texto, opcoes = {}) {
  const conteudo = texto == null ? "" : String(texto).trim();
  if (conteudo === "") return "";

  const { width = 220, margin = 1, corEscura = "#10243e", corClara = "#ffffff" } = opcoes;

  try {
    return await QRCode.toDataURL(conteudo, {
      width,
      margin,
      errorCorrectionLevel: "M",
      color: {
        dark: corEscura,
        light: corClara,
      },
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Falha ao gerar QR Code", e);
    return "";
  }
}
